import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { config } from '../../common/';
import * as Maintenance from '../../maintenance';

const BaseLayout: React.FC<{}> = () => (
    <Route
        render={() => {
            return (
                <React.Fragment>
                    <Switch>
                        <Route exact path={[`${config.BaseURL}/maintenance/packs`, `${config.AlternativeBaseURL}/maintenance/packs`]} component={Maintenance.PacksLayout} />
                    </Switch>
                </React.Fragment>
            );
        }}
    />);

export default BaseLayout;
